import React from 'react';
import PropTypes from 'prop-types';

const propTypes = {
  id: PropTypes.string,
  color: PropTypes.string,
  size: PropTypes.number,
};

const LayeringIcon = ({
  id = 'layering-icon',
  color = '#798588',
  size = 24,
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width={size}
    viewBox="0 0 24 24"
    {...props}
  >
    <defs>
      <path id={`${id}-a`} d="M0 0h24v24H0z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id={`${id}-b`} fill="#fff">
        <use xlinkHref={`#${id}-a`} />
      </mask>
      <path
        fill={color}
        d="M10.86.106a6.2 6.2 0 0 1 2.28 0c.868.164 1.614.6 2.79 1.285l5.403 3.153c.618.36 1.119.652 1.492.909.371.255.713.537.922.91.337.607.337 1.292 0 1.898-.209.374-.55.656-.922.911q-.293.2-.688.436.402.248.698.457c.372.265.712.555.917.936.33.615.33 1.304 0 1.919-.205.381-.545.672-.917.936q-.234.166-.534.355.3.188.534.354c.372.265.712.555.917.936.33.615.33 1.304 0 1.919-.205.381-.545.672-.917.936-.373.266-.874.568-1.493.941l-5.406 3.263c-1.172.708-1.92 1.16-2.791 1.33a6 6 0 0 1-2.29 0c-.87-.17-1.619-.622-2.791-1.33l-5.406-3.263c-.619-.373-1.12-.675-1.493-.94-.372-.265-.712-.556-.917-.937a1.98 1.98 0 0 1 0-1.919c.205-.38.545-.671.917-.936q.234-.166.534-.354-.3-.19-.534-.355c-.372-.264-.712-.555-.917-.936a1.98 1.98 0 0 1 0-1.919c.205-.38.545-.671.917-.936q.296-.209.698-.457a14 14 0 0 1-.688-.436c-.371-.255-.713-.537-.922-.91a1.9 1.9 0 0 1 0-1.898c.209-.374.55-.656.922-.911.373-.257.874-.549 1.492-.91l5.404-3.152C9.246.706 9.992.27 10.86.106m-7.723 14.98c-.482.293-.837.512-1.103.702-.329.233-.43.36-.465.424a.48.48 0 0 0 0 .497c.035.065.136.19.465.425.322.229.774.502 1.425.895l5.266 3.178c1.325.8 1.839 1.098 2.419 1.211a4.5 4.5 0 0 0 1.712 0c.58-.113 1.094-.411 2.42-1.211l5.265-3.178c.651-.393 1.103-.666 1.425-.895.329-.234.43-.36.465-.425a.48.48 0 0 0 0-.497c-.035-.065-.136-.19-.465-.424-.266-.19-.62-.41-1.103-.701l-4.927 2.973c-1.172.708-1.92 1.16-2.791 1.33a6 6 0 0 1-2.29 0c-.87-.17-1.619-.622-2.791-1.33zm17.531-4.617c.584.352.997.605 1.298.819.329.233.43.36.465.424a.48.48 0 0 1 0 .497c-.035.065-.136.19-.465.425-.322.229-.774.502-1.425.895l-5.266 3.178c-1.325.8-1.839 1.098-2.419 1.211a4.5 4.5 0 0 1-1.712 0c-.58-.113-1.094-.411-2.42-1.211L3.46 13.529c-.651-.393-1.103-.666-1.425-.895-.329-.234-.43-.36-.465-.425a.48.48 0 0 1 0-.497c.035-.065.136-.19.465-.424.3-.214.714-.467 1.298-.819l4.739 2.765c1.175.685 1.921 1.121 2.789 1.285a6.2 6.2 0 0 0 2.28 0c.868-.164 1.614-.6 2.79-1.285zm-7.807-8.89a4.7 4.7 0 0 0-1.722 0c-.584.111-1.1.4-2.424 1.173L3.45 5.824c-.652.38-1.104.644-1.426.865-.33.227-.428.348-.46.405a.41.41 0 0 0 0 .437c.032.057.13.178.46.405.322.221.774.485 1.426.865l5.265 3.072c1.324.772 1.84 1.062 2.424 1.173a4.7 4.7 0 0 0 1.722 0c.584-.111 1.1-.4 2.424-1.173L20.55 8.8c.652-.38 1.104-.644 1.426-.865.33-.227.428-.348.46-.405a.41.41 0 0 0 0-.437c-.032-.057-.13-.178-.46-.405-.322-.221-.774-.485-1.426-.865l-5.265-3.072C13.96 1.98 13.445 1.69 12.86 1.58"
        mask={`url(#${id}-b)`}
      />
    </g>
  </svg>
);

LayeringIcon.propTypes = propTypes;

export default LayeringIcon;
